import React, { useCallback, useState } from 'react';
import * as Styles from './ListItem.styles';
import {
  Checkbox, IconLock, SelectField, Tag, Toggle,
} from 'gatorcomponents';
import { formatCurrency } from '@/utils/Formatters/formatCurrency';

export const ListItem = ({
  available,
  domain,
  searchedDomain,
  locales,
  freeDomains,
  checkedItems,
  setCheckedItems,
  options,
  protectIdData,
}) => {
  const [selectedCycle, setSelectedCycle] = useState(options && options[0]);
  const isChecked = checkedItems.find(item => item.name === (domain && domain.name));

  const searchedDomainSld = searchedDomain && searchedDomain.split('.').shift();

  const hasFreeYear = checkedItems && checkedItems.some(item => (item.tld === '.com' || item.tld === '.com.br'))
  && freeDomains && freeDomains.some(item => item.name === (domain && domain.name));

  const extensionDescriptions = tld => locales.domainDescription[tld] && (
    <Styles.DomainDescription>
      {locales.domainDescription[tld]}
    </Styles.DomainDescription>
  );

  const handleSelectCycle = useCallback((e) => {
    setSelectedCycle(e);

    if (isChecked) {
      setCheckedItems((prevItems) => {
        const currentDomain = {
          ...domain,
          cycle: e.value,
        };

        return prevItems.map(item => (item.name === (domain && domain.name) ? currentDomain : item));
      });
    }
  }, [domain, isChecked, setCheckedItems]);

  const getSelectProps = useCallback(() => ({
    options,
    value: selectedCycle.label,
    onClickSelect: e => handleSelectCycle(e),
  }), [selectedCycle, options, handleSelectCycle]);

  const handleCheckItem = () => {
    setCheckedItems((prevItems) => {
      if (!isChecked) {
        if (!hasFreeYear) {
          const currentDomain = {
            ...domain,
            cycle: selectedCycle.value,
          };

          return [...prevItems, currentDomain];
        }

        if (hasFreeYear) {
          const currentDomain = {
            ...domain,
            radix: true,
            cycle: selectedCycle.value,
          };

          return [...prevItems, currentDomain];
        }
      }


      if (isChecked) {
        if (domain.tld === '.com' || domain.tld === '.com.br') {
          const allRadixToFalse = prevItems.map(item => ({
            ...item,
            isRadix: false,
          }));
          return allRadixToFalse.filter(item => item.name !== (domain && domain.name));
        }

        return prevItems.filter(item => item.name !== (domain && domain.name));
      }
    });
  };

  const handlePId = () => {
    setCheckedItems((prevItems) => {
      const withPid = prevItems.find(item => item.name === (domain && domain.name) && item.protectId);
      const newITems = prevItems.filter(item => item.name !== (domain && domain.name));

      if (withPid) {
        newITems.push({
          ...domain,
          cycle: selectedCycle.value,
        });
      }

      if (!withPid) {
        newITems.push({
          ...domain,
          protectId: true,
          cycle: selectedCycle.value,
        });
      }

      return newITems;
    });
  };

  const getProtectIdDataPerCycle = () => {
    const rules = {
      one: protectIdData && protectIdData.prices.renewalPricing.annually,
      two: protectIdData && protectIdData.prices.renewalPricing.biennially,
      three: protectIdData && protectIdData.prices.renewalPricing.triennially,
    };

    return rules[selectedCycle.value];
  };


  if (!available) {
    return (
      <Styles.NoAvailableListItem $isChecked={isChecked}>
        <Styles.Row>
          <Styles.NoAvailableCheckboxLabel>
            <Checkbox
              checked={false}
            />
          </Styles.NoAvailableCheckboxLabel>

          <Styles.DomainBlock>
            <Styles.NoAvailableDomainName data-testid="domain-in-use">
              {`${searchedDomainSld}.`}

              <Styles.NoAvailableDomainTld>
                {searchedDomain.replace(`${searchedDomainSld}.`, '')}
              </Styles.NoAvailableDomainTld>
            </Styles.NoAvailableDomainName>

            <Styles.DomainDescription>
              {locales.domainInUse}
            </Styles.DomainDescription>
          </Styles.DomainBlock>

          <Styles.ValueBlock>
            <Styles.DisabledList data-testid="unavailable-reasons">
              <Styles.DisabledListItemHead>{locales.domainInUseList.title}</Styles.DisabledListItemHead>
              {locales.domainInUseList.infoList.map((item, index) => (
                <Styles.DisabledListItem key={item} data-testid={`reason-${index + 1}`}>{item}</Styles.DisabledListItem>
              ))}
            </Styles.DisabledList>
          </Styles.ValueBlock>
        </Styles.Row>
      </Styles.NoAvailableListItem>
    );
  }

  return (
    <Styles.ListItem $isChecked={isChecked} data-testid="list-item-available">
      <Styles.Row>
        <Styles.CheckboxLabel htmlFor={`checkbox${(domain && domain.name)}`} onClick={handleCheckItem} data-testid={`label-${domain.name}`}>
          <Checkbox
            id={`checkbox${(domain && domain.name)}`}
            checked={isChecked}
            data-testid={`checkbox-${(domain && domain.name)}`}
          />
        </Styles.CheckboxLabel>

        <Styles.DomainBlock title={(domain && domain.name)}>
          <Styles.DomainName data-testid="domain-name">
            {`${domain.sld}`}

            <Styles.DomainTld>
              {domain.tld}
            </Styles.DomainTld>
          </Styles.DomainName>

          {extensionDescriptions((domain && domain.name).split('.').pop())}
        </Styles.DomainBlock>

        <Styles.SelectWrapper>
          <SelectField {...getSelectProps()} />
        </Styles.SelectWrapper>

        <Styles.ValueBlock>
          {hasFreeYear && (
          <>
            <Tag label={locales.radixLabel} variant="success" testId="free-year-tag" />
          </>
          )}

          {!hasFreeYear && (
            <Styles.RegisterPrice data-testid="register-price">
              {formatCurrency(domain.cycle[selectedCycle.value].priceRegister)}
            </Styles.RegisterPrice>
          )}

          <Styles.ThenLabel data-testid="then-price">
            {`${locales.thenLabel({ value: formatCurrency(domain.cycle[selectedCycle.value].priceRenew), cycle: 1 })}`}
          </Styles.ThenLabel>
        </Styles.ValueBlock>
      </Styles.Row>

      {(isChecked && domain.related) && (
        <Styles.Row>
          <Styles.ProtectIdWrapper>
            <Styles.IconWrapper>
              <IconLock color="primaryExtraDark" />
            </Styles.IconWrapper>

            <Styles.CheckboxLabel>
              <Toggle
                testId={`checkbox${(domain && domain.name)}-pid`}
                checked={domain.protectId}
                onMark={handlePId}
              />
            </Styles.CheckboxLabel>

            <Styles.Column>
              <Styles.Row $noGap>

                <Styles.ProtectIdTitle>
                  {locales.protectID.title}
                </Styles.ProtectIdTitle>
              </Styles.Row>

              <Styles.Row>
                <Styles.ProtectIdDescription data-testid="protect-id-description">
                  {locales.protectID.description({
                    price: formatCurrency(getProtectIdDataPerCycle()),
                    cycle: selectedCycle.value,
                  })}
                </Styles.ProtectIdDescription>
              </Styles.Row>
            </Styles.Column>
          </Styles.ProtectIdWrapper>
        </Styles.Row>
      )}
    </Styles.ListItem>
  );
};

export default ListItem;
